const text = (value) => (typeof value === 'string' ? value.trim() : '');

const pythonVersion = (value) =>
  value.match(/(?:^|[\s;(])(?:cpython|python)[ /]([0-9][^\s;()]*)/i)?.[1] || '';

function knownUserAgent(userAgent) {
  const photoshop = userAgent.match(
    /(?:^|[\s;(])(?:adobe )?photoshop\/([0-9][^\s;()]*)/i
  );
  if (photoshop) return { name: 'Photoshop', version: photoshop[1] };
  const cherry = userAgent.match(
    /(?:^|[\s;(])cherry[ -]?studio[ /]([0-9][^\s;()]*)/i
  );
  if (cherry) return { name: 'Cherry Studio', version: cherry[1] };
  const version = pythonVersion(userAgent);
  if (
    version ||
    /(?:python-requests\/|python-httpx\/|openai\/python|anthropic\/python)/i.test(
      userAgent
    )
  ) {
    return { name: 'Python', version };
  }
  return null;
}

// Presentation only: retain stored attribution, detection metadata and raw exports.
export function logClientIdentityV94(log) {
  const userAgent = text(log?.client_user_agent);
  const app = text(log?.client_app);
  const detected = knownUserAgent(userAgent);
  const runtimeVersion = pythonVersion(text(log?.client_runtime));
  if (app === 'Python Requests') {
    return { name: 'Python', version: runtimeVersion, userAgent };
  }
  if (app && !(userAgent && log?.client_detection_source === 'referer')) {
    return {
      name: app,
      version:
        text(log?.client_version) ||
        (detected?.name === app ? detected.version : '') ||
        (app === 'Python' ? runtimeVersion : ''),
      userAgent,
    };
  }
  if (detected) {
    return {
      ...detected,
      version:
        detected.version || (detected.name === 'Python' ? runtimeVersion : ''),
      userAgent,
    };
  }
  if (userAgent) return { name: userAgent, version: '', userAgent };
  const sdk = text(log?.client_sdk);
  if (/\bpython\b/i.test(sdk)) {
    return { name: 'Python', version: runtimeVersion, userAgent };
  }
  return {
    name: sdk || text(log?.client_origin),
    version: '',
    userAgent,
  };
}
